import { render, staticRenderFns } from "./own_inventory.vue?vue&type=template&id=52956956&"
import script from "./own_inventory.vue?vue&type=script&lang=js&"
export * from "./own_inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports